import * as v from "valibot";
import { ArticleView } from "../models/article";
import { pageRequest, pageResponse } from "./paging.dto";
import { articleKey, authorInfoDto, authorsByAliasDto, imageDto, searchArticleMetaDto } from "./shared.dto";

export const keyPointDto = v.object({
  title: v.string(),
  paragraphs: v.array(v.string()),
  takeaway: v.string(),
  image: v.optional(imageDto),
});

export const articleDto = v.object({
  authorAlias: v.string(),
  id: v.string(),
  summary: v.array(v.string()),
  introduction: v.array(v.string()),
  keyPoints: v.array(keyPointDto),
  conclusion: v.array(v.string()),
  disclaimer: v.optional(v.boolean()),
  disclaimerReasons: v.optional(v.array(v.string())),
  metaDescription: v.string(),
  searchKeywords: v.array(v.string()),
});
export type ArticleDto = v.InferOutput<typeof articleDto>;

export const getArticleRequest = articleKey;
export const getArticleResponse = {
  article: articleDto,
  meta: searchArticleMetaDto,
  author: authorInfoDto,
};

export const getArticleRecommendationsRequest = articleKey;
export const getArticleRecommendationsResponse = {
  moreFromAuthor: v.array(searchArticleMetaDto),
  youMayAlsoLike: v.array(searchArticleMetaDto),
  authors: authorsByAliasDto,
};

const filterText = v.pipe(v.string(), v.maxLength(64));

export const articleFilterDto = v.object({
  category: v.optional(filterText),
  subcategory: v.optional(filterText),
  author: v.optional(filterText),
  collectionId: v.optional(filterText),
  // Only the global, all-time ranking is backed by data.
  popularityPartition: v.optional(v.picklist(["global"])),
  popularityPeriod: v.optional(v.picklist(["allTime"])),
});
export type ArticleFilterDto = v.InferOutput<typeof articleFilterDto>;

export const ARTICLE_VIEWS: ArticleView[] = Object.values(ArticleView);

export const searchArticlesRequest = {
  view: v.picklist(ARTICLE_VIEWS),
  filter: v.optional(articleFilterDto),
  ...pageRequest,
};

export const searchArticlesResponse = {
  metas: v.array(searchArticleMetaDto),
  authors: authorsByAliasDto,
  ...pageResponse,
};
